import { useState,useEffect } from "react";


const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
    zIndex: 999,
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  navPanel: {
    overflowY: 'scroll',
    transform: 'translateX(100%)',
    top: 0,
    right: 0,
    bottom: 0,
    width: '350px',
    height: '100%',
    position: 'fixed',
    zIndex: 99999,
    backgroundColor: '#fff',
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.5s cubic-bezier(0.77, 0, 0.175, 1)',
  },
  navPanelOpen: {
    transform: 'translateX(0)',
  },
  closeBtn: {
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    color: '#ccc',
    display: 'inline-block',
    textAlign: 'center',
    position: 'absolute',
    right: '25px',
    top: 0,
  },
  closeIcon: {
    fontSize: '2.625rem',
  },
  logoPanel: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '140px',
    backgroundColor: '#517874',
    padding: '20px',
    position: 'relative',
  },
  sidebarNav: {
    overflowX: 'hidden',
    width: '100%',
    position: 'absolute',
    paddingTop: '30px',
    top: '140px',
    bottom: 0,
    left: 0,
    paddingLeft: '25px',
    paddingRight: '25px',
    zIndex: 9999,
    backgroundColor: '#EFE2D2',
  },
  navList: {
    paddingTop: '30px',
    listStyle: 'none',
    position: 'absolute',
    top: '31px',
    padding: '0',
    width: '100%',
    height: '100%',
    background: '#EFE2D2',
    transition: 'all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1)',
    zIndex: 1,
  },
  navLink: {
    fontSize: '14px',
    color: '#517874',
    textDecoration: 'none',
    fontWeight: 500,
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: '12px',
    padding: '6px 0',
    transition: 'all 0.3s ease',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 99999,
    padding: '20px 25px',
    fontSize: '12px',
    textAlign: 'center',
  },
  phone: {
    padding: '15px 0',
    position: 'relative',
    lineHeight: 1.4,
    textAlign: 'center',
  },
  phoneLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  phoneIcon: {
    marginRight: '0',
    marginBottom: '5px',
    fontSize: '1.5rem',
    color: '#517874',
  },
  phoneText: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: '#517874',
    display: 'block',
  },
  phoneSub: {
    color: '#517874',
    display: 'block',
    fontStyle: 'inherit',
    textTransform: 'uppercase',
    fontSize: '0.85rem',
    fontWeight: 500,
    letterSpacing: '2px',
    marginBottom: '5px',
  },
  credit: {
    paddingBottom: '20px',
    color: '#517874',
    textAlign: 'center',
    fontSize: '0.9rem',
  },
};


const SideNavigation = ({ isOpen, onClose }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
const navPanelStyle = {
  ...styles.navPanel,
  ...(isOpen ? styles.navPanelOpen : {}),
  ...(isMobile ? { width: '100%' } : {}),
};


  return (
    <>
      <div
        style={{
          ...styles.overlay,
          ...(isOpen ? styles.overlayVisible : {}),
        }}
        onClick={onClose}
      />

      <div style={navPanelStyle}>
  <div style={styles.logoPanel}>
    {/* Close Button */}
    <button 
      className="closebt open_close_nav_panel"
      onClick={onClose}
      style={{
        position: 'absolute',
        top: '15px',
        right: '15px',
        background: 'none',
        border: 'none',
        color: '#fff',
        fontSize: '24px',
        cursor: 'pointer',
        zIndex: 10
      }}
    >
      <i className="bi bi-x"></i>
    </button>

    {/* Centered Logo and Text */}
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      width: '100%',
      marginTop: '35px'
    }}>
      <img
        src="/assets/img/logo/pettipettilogo.png"
        alt="Petti Petti Logo"
        style={{ 
          height: '80px',
          width: 'auto',
          filter: 'brightness(0) invert(1)',
          marginBottom: '15px'
        }}
      />

    </div>
  </div>

        <div style={styles.sidebarNav}>
          <nav>
            <ul style={styles.navList}>
              {[
                ['HOME', '/'],
                ['EAT & DRINK', '/dining'],
                ['EVENTS', '/events'],
                ['OFFERS', '/offers'],
                ['GALLERY', '/gallery'],
                ['ABOUT US', '/about'],
                ['CONTACT US', '/contact'],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} style={styles.navLink}>
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/lounge"
                  style={{...styles.navLink, fontWeight: 'bold'}}
                >
                  RESERVE YOUR LOUNGE
                </a>
              </li>
            </ul>

            <div style={styles.footer}>
              <div style={styles.phone}>
                <a href="tel:+94761407881" style={styles.phoneLink}>
                  <i className="bi bi-telephone" style={styles.phoneIcon}></i>
                  <em style={styles.phoneSub}>Contact Us</em>
                  <span style={styles.phoneText}>+94 76 140 7881</span>
                </a>
              </div>
              <div style={styles.credit}>
                Designed and Developed by<br />
                <a
                  href="https://ollcode.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#517874' }}
                >
                  <b>OLLCODE</b>
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default SideNavigation;